/**
 * Fetch data from given url
 * @param {*} url
 * @param {*} options
 */
import axios from "axios";

const fetchJSON = async (url, headerParams = {}, body = {}) => {
  return axios
    .get(
      url,
      {
        body, // only if not an object. Otherwise don't use outer {},
      },
      headerParams
    )
    .then((response) => response.data)
    .catch((err) => {
      throw err;
    });
};
const postJSON = async (url, body = {}) => {
  console.log(`body`, body);
  return axios
    .post(
      url,
      body // only if not an object. Otherwise don't use outer {},
    )
    .then((response) => response.data)
    .catch((err) => {
      throw err;
    });
};

export { fetchJSON, postJSON };
